<template>
     <span>
        <el-button type="warning" plain  icon="el-icon-download" v-on:click="clickEvent('pdf')">导出PDF</el-button>
        <el-button type="warning" plain  icon="el-icon-download" v-on:click="clickEvent('word')">导出word</el-button>
    </span>
</template>
  
  <script>
  
  export default {
    name: 'download-form-button',
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(type){
            this.$emit('select-type',type);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// DownloadFormButton.vue?0ea4a441